import { pluralize } from '@/react/common/string-utils';

import { PortainerSelect } from '@@/form-components/PortainerSelect';
import { Input } from '@@/form-components/Input';
import { InputGroup } from '@@/form-components/InputGroup';

import { durationAmount, durationUnit } from './duration';

interface Props {
  value: string;
  onChange: (duration: string) => void;
  min?: number;
  disabled?: boolean;
  id: string;
}

export function DurationInput({
  value,
  onChange,
  min = 0,
  disabled,
  id,
}: Props) {
  const amount = durationAmount(value);
  const unit = durationUnit(value);

  return (
    <InputGroup className="flex">
      <Input
        id={id}
        type="number"
        value={amount}
        onChange={(e) => {
          const n = Math.max(min, Math.round(Number(e.target.value)));
          onChange(`${n}${unit}`);
        }}
        min={min}
        step={1}
        disabled={disabled}
        data-cy="duration-input-value"
        className="!w-1/2 !border-r-0"
      />
      <div className="w-1/2">
        <PortainerSelect
          value={unit}
          onChange={(value) => onChange(`${amount}${value}`)}
          disabled={disabled}
          data-cy={`duration-input-unit-${id}`}
          options={[
            { label: pluralize(amount, 'minute'), value: 'm' },
            { label: pluralize(amount, 'hour'), value: 'h' },
            { label: pluralize(amount, 'day'), value: 'd' },
            { label: pluralize(amount, 'week'), value: 'w' },
          ]}
        ></PortainerSelect>
      </div>
    </InputGroup>
  );
}
